import React, { useEffect, useState } from "react";
import "./home.scss";
import { Link, useParams } from "react-router-dom";
import { GameAllCalls } from "../../hooks/dataSender/gameEndTime";
import { callCrashGameGraphQLQuery } from "../../utils/axiosClient";
import Web3 from "web3";
const Home = () => {
  const { id } = useParams();
  const [currentIndex, setCurrentIndex] = useState(null);
  const [mainArry, setMainArry] = useState(null);
  const { GameCurrentIndexHood, GamePendingHook, GameRoundHook } =
    GameAllCalls();

  function shortenAddress(address, chars = 4) {
    if (!address) return "";
    return `${address.slice(0, 2 + chars)}...${address.slice(-chars)}`;
  }

  // const getCurrentIndex = async () => {
  //   let index = await GameCurrentIndexHood();
  //   toTheMoonData(index);
  // };
  useEffect(() => {
    // getCurrentIndex();
    toTheMoonData0();
  }, [currentIndex]);
  useEffect(() => {
    if (id) {
      console.log(id, "idididid");

      localStorage.setItem("route", id);
    }
  }, []);
  const toTheMoonData0 = async (currentIndex) => {
    const query = `
            query crashBetResolveds{
        crashBetResolveds(orderBy: index, orderDirection: desc) {
                index
          won
          transactionHash
          amount
          timepassed
          player
          payout
          id
          blockTimestamp
          blockNumber
        }
      }
            `;

    try {
      const data = await callCrashGameGraphQLQuery(query);
      toTheMoonData(data.crashBetResolveds[0].index);
    } catch (error) {}
  };
  const toTheMoonData = async (currentIndex) => {
    const query = `
             query crashBetResolveds{
        crashBetResolveds(where: {index: ${currentIndex}}) {
                index
          won
          transactionHash
          amount
          timepassed
          player
          payout
          id
          blockTimestamp
          blockNumber
        }
      }
            `;

    try {
      const data = await callCrashGameGraphQLQuery(query);

      const allBets = data?.crashBetResolveds || [];
      allBets.forEach((obj) => {
        obj.game = "Crash"; // adding static string
      });
      // setMainArry(allBets);
      toTheMoonData1(allBets);
    } catch (error) {
      // setLoading(false);
    }
  };
  const toTheMoonData1 = async (allBetsss) => {
    const query = `
          query GetResolvedBets {
       betResolveds(orderBy: blockTimestamp, orderDirection: desc){
  won
  player
  payout
  amount
  odds
  transactionHash
  blockTimestamp
}
      }
            `;

    try {
      const data = await callCrashGameGraphQLQuery(query);

      const allBets = data?.betResolveds || [];

      allBets.forEach((obj) => {
        obj.game = "Dice"; // adding static string
      });
      let c = allBetsss?.concat(allBets[0]);

      setMainArry(c);
    } catch (error) {
      console.log("allBets", error);

      // setLoading(false);
    }
  };

  return (
    <>
      <section className="homemain">
        <div className="custom-container">
          <div className="mainhomebox">
            <img src="/assets/homebg.png" alt="bannerbg" className="bannerbg" />
            <img
              src="/assets/homemainimg.png"
              alt="leftmainimg"
              className="leftmainimg"
            />
            <img
              src="/assets/homemainimgmbl.png"
              alt="leftmainimg"
              className="leftmainimgmbl d-none"
            />
            <h2>Are You Ready for Liftoff?</h2>
            <p>
              Pick your game, test your luck, and join a new era of Web3 gaming.
            </p>
          </div>
          <p className="gamespara">Games</p>
          <div className="maincardsparent">
            <Link to="/play" className="innercard">
              <div className="img">
                {window.innerWidth > 500 ? (
                  <img
                    src="/assets/dicegame.png"
                    alt="img"
                    className="cardimage"
                  />
                ) : (
                  <img
                    src="/assets/dicegamembl.png"
                    alt="img"
                    className="cardimage"
                  />
                )}
                <h2 className="headodd">Dice</h2>
                <span className="shade"></span>
              </div>

              {/* <div className="activemain">
                <p className="playerpara">Active Players</p>
                <div className="playernumber">
                  <p className="numberpara">321</p>
                  <span className="circle"></span>
                </div>
                <p className="playingpara d-none">Playing</p>
              </div> */}
            </Link>
            <Link to="/tothemoon" className="innercard">
              <div className="img">
                {window.innerWidth > 500 ? (
                  <img
                    src="/assets/moongame.png"
                    alt="img"
                    className="cardimage"
                  />
                ) : (
                  <img
                    src="/assets/moongamembl.png"
                    alt="img"
                    className="cardimage"
                  />
                )}
                <h2 className="headodd">Crash</h2>
                    <span className="shade"></span>
              </div>

              {/* <div className="activemain">
                <p className="playerpara">Active Players</p>
                <div className="playernumber">
                  <p className="numberpara">398</p>
                  <span className="circle"></span>
                </div>
                <p className="playingpara d-none">Playing</p>
              </div> */}
            </Link>
            <div to="" style={{cursor: 'not-allowed'}} className="innercard">
              <div className="img">
                {window.innerWidth > 500 ? (
                  <img
                    src="/assets/newgame.png"
                    alt="img"
                    className="cardimage"
                  />
                ) : (
                  <img
                    src="/assets/plinkogamembl.png"
                    alt="img"
                    className="cardimage"
                  />
                )}
                <h2 className="headodd">Plinko <span className="comingtext">Coming soon</span></h2>
                    <span className="shade"></span>
              </div>

              {/* <div className="activemain">
                <p className="playerpara">Active Players</p>
                <div className="playernumber">
                  <p className="numberpara">0</p>
                  <span className="circle"></span>
                </div>
                <p className="playingpara d-none">Playing</p>
              </div> */}
            </div>
          </div>
          <section className="maininnerlower">
            <div className="playtable">
              <h6 class="playhead">Latest Round and Race</h6>
              <div className="maintable">
                <div className="innertable">
                  <table>
                    <thead>
                      <tr>
                        <th>Game</th>
                        <th>Player</th>
                        <th>Bet Amount</th>
                        <th>Multiplier</th>
                        <th>PNL</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mainArry &&
                        mainArry?.length > 0 &&
                        mainArry?.map((bet) => (
                          <tr>
                            <td>{bet.game}</td>
                            <td>{shortenAddress(bet?.player)}</td>
                            <td>
                              $
                              {(() => {
                                const betAmountInEther = parseFloat(
                                  Web3?.utils?.fromWei(
                                    String(bet?.amount),
                                    "mwei"
                                  )
                                );
                                return betAmountInEther?.toFixed(2);
                              })()}
                            </td>
                            <td>
                              {/* {parseFloat(
                                Web3.utils.fromWei(String(bet.payout), "mwei")
                              ).toFixed(2) /
                                parseFloat(
                                  Web3?.utils?.fromWei(
                                    String(bet?.amount),
                                    "mwei"
                                  )
                                ).toFixed(2)} */}
                              {(() => {
                                const betAmountInEther = parseFloat(
                                  Web3?.utils?.fromWei(
                                    String(bet?.amount),
                                    "mwei"
                                  )
                                );
                                const payout = parseFloat(
                                  Web3?.utils?.fromWei(
                                    String(bet?.payout),
                                    "mwei"
                                  )
                                );
                                let final = payout / betAmountInEther;

                                return final?.toFixed(2);
                              })()}
                              x
                            </td>
                            <td>
                              {(() => {
                                const betAmountInEther = parseFloat(
                                  Web3?.utils?.fromWei(
                                    String(bet?.amount),
                                    "mwei"
                                  )
                                );
                                const payout = parseFloat(
                                  Web3?.utils?.fromWei(
                                    String(bet?.payout),
                                    "mwei"
                                  )
                                );
                                const final = payout - betAmountInEther;

                                return (
                                  <p
                                    className={
                                      final < 0 ? "redpara" : "greenpara"
                                    }
                                  >
                                    {final?.toFixed(2)}
                                  </p>
                                );
                              })()}
                            </td>
                          </tr>
                        ))}
                      {/* <tr>
                        <td>To The Moon</td>
                        <td>User1234</td>
                        <td>$1,500</td>
                        <td>1.5x</td>
                        <td>
                          <p className="redpara">457.57</p>
                        </td>
                      </tr>
                      <tr>
                        <td>To The Moon</td>
                        <td>User1234</td>
                        <td>$1,500</td>
                        <td>1.5x</td>
                        <td>
                          <p className="greenpara">457.57</p>
                        </td>
                      </tr> */}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="mainboxes d-block d-md-none">
                {/* <div className="mainbox">

                  <div className="innerbox">
                    <p className="boxpara">Game</p>
                    <h6 className="boxhead">To The Moon</h6>
                  </div>
                  <div className="innerbox">
                    <p className="boxpara">Player</p>
                    <h6 className="boxhead">User1234</h6>
                  </div>
                  <div className="innerbox">
                    <p className="boxpara">Bet Amount</p>
                    <h6 className="boxhead">$1,500</h6>
                  </div>
                  <div className="innerbox">
                    <p className="boxpara">Multiplier</p>
                    <h6 className="boxhead">1.5x</h6>
                  </div>
                  <div className="innerbox">
                    <p className="boxpara">PNL</p>
                    <h6 className="greenpara">457.57</h6>
                  </div>
                </div> */}

                {mainArry &&
                  mainArry?.length > 0 &&
                  mainArry?.map((bet) => (
                    <div className="mainbox">
                      <div className="innerbox">
                        <p className="boxpara">Game</p>
                        <h6 className="boxhead">{bet.game}</h6>
                      </div>
                      <div className="innerbox">
                        <p className="boxpara">Player</p>
                        <h6 className="boxhead">
                          {shortenAddress(bet?.player)}
                        </h6>
                      </div>
                      <div className="innerbox">
                        <p className="boxpara">Bet Amount</p>
                        <h6 className="boxhead">
                          {" "}
                          $
                          {(() => {
                            const betAmountInEther = parseFloat(
                              Web3?.utils?.fromWei(String(bet?.amount), "mwei")
                            );
                            return betAmountInEther?.toFixed(2);
                          })()}
                        </h6>
                      </div>
                      <div className="innerbox">
                        <p className="boxpara">Multiplier</p>
                        <h6 className="boxhead">
                          {" "}
                          {(() => {
                            const betAmountInEther = parseFloat(
                              Web3?.utils?.fromWei(String(bet?.amount), "mwei")
                            );
                            const payout = parseFloat(
                              Web3?.utils?.fromWei(String(bet?.payout), "mwei")
                            );
                            let final = payout / betAmountInEther;

                            return final?.toFixed(2);
                          })()}
                          x
                        </h6>
                      </div>
                      <div className="innerbox">
                        <p className="boxpara">PNL</p>
                        {(() => {
                          const betAmountInEther = parseFloat(
                            Web3?.utils?.fromWei(String(bet?.amount), "mwei")
                          );
                          const payout = parseFloat(
                            Web3?.utils?.fromWei(String(bet?.payout), "mwei")
                          );
                          const final = payout - betAmountInEther;

                          return (
                            <p className={final < 0 ? "redpara" : "greenpara"}>
                              {final?.toFixed(2)}
                            </p>
                          );
                        })()}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </section>
        </div>
      </section>
    </>
  );
};

export default Home;
